/**
 * Azure configuration and environment variables
 */

import { VoiceLiveConnectionConfig, VoiceLiveSessionConfig } from '../types/voiceLive.types';
import { getAgeProfile } from './ageProfiles.config';
import { getJson, postJson, API_ENDPOINTS } from '../utils/apiUtils';

export interface AzureConfig {
  backendUrl: string;
  websocketUrl?: string;
  healthCheckInterval: number;
  reconnectAttempts: number;
  reconnectDelay: number;
}

export const azureConfig: AzureConfig = {
  backendUrl: process.env.REACT_APP_API_BASE_URL || 'https://learning-companion-be-dev.data-nonprod.edgenuity.com',
  healthCheckInterval: 30000, // 30 seconds
  reconnectAttempts: 5,
  reconnectDelay: 2000, // 2 seconds
};

export const getWebSocketUrl = async (): Promise<string> => {
  const response = await getJson(API_ENDPOINTS.CONFIG_WEBSOCKET_URL);
  if (!response.ok) {
    throw new Error('Failed to get WebSocket URL from backend');
  }
  const data = await response.json();
  return data.websocket_url;
};

export const createVoiceLiveConfig = async (conversationId: string, userAge: number): Promise<VoiceLiveConnectionConfig> => {
  // Always use backend session configuration
  // Backend controls Azure VoiceLive WebSocket connection, so frontend must get config from backend
  const response = await postJson(API_ENDPOINTS.CONFIG_SESSION, {
    conversation_id: conversationId,
    user_age: userAge,
    // Don't pass custom_instructions so it uses the story introduction logic
  });

  if (!response.ok) {
    throw new Error(`Failed to get session configuration from backend: ${response.statusText}. VoiceLive requires backend to be available.`);
  }

  const sessionData = await response.json();

  return {
    websocket_url: sessionData.websocket_url,
    conversation_id: conversationId,
    session_config: sessionData.session_config
  };
};